import { Paper, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { createSelectField } from '../../../components/temp/componentBuiderTemp';
import { TitleDivider } from '../../../components/titleDivider';
import { correspondentBetaOptions, correspondentBetaPercentageOptions } from '../../../utils/constants';
import { QuoteTypeStore } from '../../../stores/quoteTypeStore';

export const WHOLE_LOAN = 'Whole Loan';
export const NO_PARTICIPATION = 'Broker Loan';
export const NO_PARTICIPATION_PERCENTAGE = 0.0;
export const WHOLE_LOAN_PERCENTAGE = 100.0;

const useStyles = makeStyles(theme => ({
  paper: {
    border: `1px solid lightgray`,
    borderRadius: '16px !important',
    padding: theme.spacing(4),
  },
}));

interface CorrespondentBetaCardProps {
  store: QuoteTypeStore;
}

export const CorrespondentBetaCard = observer(
  ({ store }: CorrespondentBetaCardProps) => {
    const classes = useStyles();
    const { closingFormStore } = store.closingStore;
    const sellAs = closingFormStore.form.fields.sellAs.value;

    const handleSellAsChange = value => {
      closingFormStore.onFieldChange('sellAs', value);
      if (value === NO_PARTICIPATION) {
        closingFormStore.onFieldChange(
          'origLenderSubordination',
          NO_PARTICIPATION_PERCENTAGE
        );
      } else if (value === WHOLE_LOAN) {
        closingFormStore.onFieldChange(
          'origLenderSubordination',
          WHOLE_LOAN_PERCENTAGE
        );
        store.loanEconomicsStore.resetCapitalProviderFees();
      } else if (
        closingFormStore.form.fields.origLenderSubordination.value ===
        WHOLE_LOAN_PERCENTAGE
      ) {
        closingFormStore.onFieldChange('origLenderSubordination', null);
      }
    };

    const handlePercentageChange = value => {
      closingFormStore.onFieldChange('origLenderSubordination', value);
      if (value === NO_PARTICIPATION_PERCENTAGE) {
        closingFormStore.onFieldChange('sellAs', NO_PARTICIPATION);
      }
    };

    const percentageOptions =
      sellAs === WHOLE_LOAN ?
        [...correspondentBetaPercentageOptions, { value: WHOLE_LOAN_PERCENTAGE, label: `${WHOLE_LOAN_PERCENTAGE}%` },] :
        correspondentBetaPercentageOptions;

    return (
      <Paper className={classes.paper} elevation={0}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TitleDivider title="Participation" />
          </Grid>
          <Grid item xs={12} sm={6}>
            {createSelectField({
              store: closingFormStore,
              testId: 'sellAs',
              fieldName: 'sellAs',
              label: 'Participation',
              options: correspondentBetaOptions,
              standaloneLabel: false,
              addMarkForRequiredFields: false,
              onChange: handleSellAsChange,
            })}
          </Grid>
          <Grid item xs={12} sm={6}>
            {createSelectField({
              store: closingFormStore,
              testId: 'origLenderSubordination',
              fieldName: 'origLenderSubordination',
              label: 'Participation Percentage',
              options: percentageOptions,
              standaloneLabel: false,
              addMarkForRequiredFields: false,
              disabled: sellAs === NO_PARTICIPATION || sellAs === WHOLE_LOAN,
              onChange: handlePercentageChange,
            })}
          </Grid>
        </Grid>
      </Paper>
    );
  }
);
